export default (
	dropdown: HTMLElement,
	dropdowns: HTMLElement | null = null
) => {
	if (!dropdown) return;

	const label: HTMLElement | null =
		dropdown.querySelector(".dropdown__label");
	const options: Array<HTMLElement> = Array.from(
		dropdown.querySelectorAll(".dropdown__options .option")
	);

	if (!label || !options) return;

	label.onclick = () => {
		if (dropdowns) {
			const deployedDropdowns: Array<HTMLElement> = Array.from(
				dropdowns.querySelectorAll(".open")
			);

			deployedDropdowns.map((deployedDropdown: HTMLElement) => {
				if (deployedDropdown !== dropdown) {
					deployedDropdown.classList.remove("open");
				}
			});
		}

		dropdown.classList.toggle("open");
	};
};
